// i18n keys of the multi-tenant work package "ctrlplane" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
// Sign-in page titles (brand from GET /api/public/brand) and the client portal address (Workspace card, Client Portal admin).
export const en: Record<string, string> = {
  ctrl_system_title: '{{brand}} System',
  ctrl_system_generic: 'Management System',
  ctrl_portal_title: '{{brand}} Client Portal',
  ctrl_portal_generic: 'Client Portal',
  ctrl_logo_alt: 'Logo',
  ctrl_portal_base: 'Client portal address',
  ctrl_portal_base_hint: 'Where clients sign in to the invoicing portal; printed in every portal account message. Empty = the public base URL + /portal.',
  ctrl_portal_base_env: 'Set by PORTAL_BASE_URL in the server environment.',
  ctrl_portal_base_in_use: 'In use: {{url}}',
  ctrl_portal_base_default: 'In use (default): {{url}}',
  ctrl_portal_base_unset: 'Not set: clients cannot be given a sign-in address. Set this or the public base URL.',
  ctrl_portal_cors_gap: 'The server does not allow {{origin}}, so the browser will refuse sign-ins from the portal. Add it to server/.env exactly as shown (no trailing slash), plus the origin it redirects to if it redirects (e.g. www → no www), then restart the server: in PORTAL_CORS_ORIGIN if the portal page there is another installation\'s, in CORS_ORIGIN if it is this installation\'s own page.',
  ctrl_portal_unset_admin: 'The client portal address is not set (Admin → Companies → Workspace).',
};
export const zh: Record<string, string> = {
  ctrl_system_title: '{{brand}} 系统',
  ctrl_system_generic: '管理系统',
  ctrl_portal_title: '{{brand}} 客户门户',
  ctrl_portal_generic: '客户门户',
  ctrl_logo_alt: '标志',
  ctrl_portal_base: '客户门户地址',
  ctrl_portal_base_hint: '客户登录开票门户的地址,所有门户开户消息都会印出它。留空 = 公共网址 + /portal。',
  ctrl_portal_base_env: '由服务器环境变量 PORTAL_BASE_URL 指定。',
  ctrl_portal_base_in_use: '当前使用:{{url}}',
  ctrl_portal_base_default: '当前使用(默认):{{url}}',
  ctrl_portal_base_unset: '未设置:无法告诉客户去哪里登录。请填写此项或公共网址。',
  ctrl_portal_cors_gap: '服务器未放行 {{origin}},门户的登录会被浏览器拒绝。请把它按这里显示的原样(末尾不加斜杠)加进 server/.env;该地址若会跳转(例如 www 跳到不带 www),跳转后的 https://域名 也要一起加;改完重启服务器。门户页面属于另一套系统时加到 PORTAL_CORS_ORIGIN,是本系统自己的页面时加到 CORS_ORIGIN。',
  ctrl_portal_unset_admin: '客户门户地址未设置(管理 → 公司 → 工作区)。',
};
export const th: Record<string, string> = {
  ctrl_system_title: 'ระบบ {{brand}}',
  ctrl_system_generic: 'ระบบบริหารจัดการ',
  ctrl_portal_title: 'พอร์ทัลลูกค้า {{brand}}',
  ctrl_portal_generic: 'พอร์ทัลลูกค้า',
  ctrl_logo_alt: 'โลโก้',
  ctrl_portal_base: 'ที่อยู่พอร์ทัลลูกค้า',
  ctrl_portal_base_hint: 'ที่อยู่ที่ลูกค้าใช้เข้าสู่ระบบพอร์ทัลออกเอกสาร ซึ่งจะพิมพ์อยู่ในทุกข้อความแจ้งบัญชีพอร์ทัล เว้นว่าง = URL สาธารณะ + /portal',
  ctrl_portal_base_env: 'กำหนดโดย PORTAL_BASE_URL ในสภาพแวดล้อมของเซิร์ฟเวอร์',
  ctrl_portal_base_in_use: 'ที่ใช้อยู่: {{url}}',
  ctrl_portal_base_default: 'ที่ใช้อยู่ (ค่าเริ่มต้น): {{url}}',
  ctrl_portal_base_unset: 'ยังไม่ได้ตั้งค่า: ไม่สามารถแจ้งที่อยู่เข้าสู่ระบบให้ลูกค้าได้ กรุณาตั้งค่านี้หรือ URL สาธารณะ',
  ctrl_portal_cors_gap: 'เซิร์ฟเวอร์ยังไม่อนุญาต {{origin}} เบราว์เซอร์จึงจะปฏิเสธการเข้าสู่ระบบจากพอร์ทัล กรุณาเพิ่มลงใน server/.env ให้ตรงตามที่แสดงนี้ทุกตัวอักษร (ไม่มี / ต่อท้าย) หากที่อยู่นี้เปลี่ยนเส้นทางไปที่อื่น (เช่น จาก www ไปยังโดเมนที่ไม่มี www) ให้เพิ่ม https://โดเมนปลายทางด้วย แล้วรีสตาร์ตเซิร์ฟเวอร์ โดยเพิ่มใน PORTAL_CORS_ORIGIN หากหน้าพอร์ทัลนั้นเป็นของระบบอื่น หรือใน CORS_ORIGIN หากเป็นหน้าของระบบนี้เอง',
  ctrl_portal_unset_admin: 'ยังไม่ได้ตั้งค่าที่อยู่พอร์ทัลลูกค้า (ผู้ดูแลระบบ → บริษัท → พื้นที่ทำงาน)',
};
